import { AssocUtilisateurFerme } from './../models/assocutilisateurferme.model';
import { FermeService } from './ferme.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment'
import { Utilisateur } from '../models/utilisateur.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import { throwError } from 'rxjs';
import { Ferme } from '../models/ferme.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type':  'application/json',
    'Authorization': 'access_token',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class AssocUtilisateurFermeService {

  baseUrl: string = environment.apiUrl;
  selectedFerme: Ferme;
  constructor(private httpClient: HttpClient, private fermeService: FermeService) {
    this.selectedFerme = fermeService.selectedFerme;
  }

  update_utilisateur(utilisateur: Utilisateur) {

  }

  delete_auf(utilisateurId: Number) {
    return this.httpClient.delete(this.baseUrl + '/auf/delete/' + utilisateurId, httpOptions)
    .catch((error: any) => {
      return throwError(error);
    });
  }

  create_auf(utilisateurId: Number) {
    const assocutilisateurferme = new AssocUtilisateurFerme(utilisateurId, this.selectedFerme.id);
    return this.httpClient.post<AssocUtilisateurFerme>(this.baseUrl + '/auf/create', assocutilisateurferme, httpOptions)
    .catch((error: any) => {
      return throwError(error);
    });
  }

  update_auf(utilisateurId: number, fermeTab: Array<Number>){
    return this.httpClient.post<AssocUtilisateurFerme>(this.baseUrl + '/auf/create/' + utilisateurId, fermeTab, httpOptions)
    .catch((error: any) => {
      return throwError(error);
    });
  }
}
